module.exports = __webpack_public_path__ + "img/level3addon_running.de0d4d7b.png";